import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Header, Segment, Button, Modal, Message, Icon, Table } from 'semantic-ui-react'

import { deleteClient } from '../../actions/clientsActions'

import NotFound from '../../NotFound'
import BottomButtons from '../../Shared/BottomButtons'

class ClientDetails extends Component {
    state = { modalOpen: false, loading: false, error: '' }

    closeModal = () => {
        if (this.state.loading) return
        this.setState({ modalOpen: false })
    }

    openModal = () => this.setState({ modalOpen: true })

    deleteClient = () => {
        var name = this.props.match.params.name
        this.props.deleteClient(name)
            .catch(err => {
                this.setState({ loading: false, error: err.message, modalOpen: false })
            })
    }

    render() {
        const { client } = this.props
        const { modalOpen, loading, error } = this.state

        if (!client) return <NotFound />

        return (
            <div>
                <Header as="h2">Asiakkaan tiedot</Header>

                <Segment size="large">
                    <Table style={{ marginBottom: '20px' }} definition>
                        <Table.Body>

                            <Table.Row>
                                <Table.Cell width={5}>Nimi</Table.Cell>
                                <Table.Cell textAlign="left">
                                    {client.name}
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={5}>Luotu</Table.Cell>
                                <Table.Cell textAlign="left">
                                    {client.created_at.substring(0, 10)}
                                </Table.Cell>
                            </Table.Row>

                            <Table.Row>
                                <Table.Cell width={5}>Asiakkaan linkki</Table.Cell>
                                <Table.Cell textAlign="left">
                                    <Link to={`/asiakkaat/${client.privatelink}`}>
                                        Jaettava linkki
                                </Link>
                                </Table.Cell>
                            </Table.Row>

                        </Table.Body>
                    </Table>


                    <BottomButtons>
                        <Button primary as={Link} to="/admin/asiakkaat">
                            <Icon name="arrow left" />
                            Takaisin
                        </Button>
                        <Button negative onClick={this.openModal}>
                            <Icon name="remove user" />
                            Poista asiakas
                        </Button>
                    </BottomButtons>


                    {!error ? null :
                        <Message error style={{ clear: 'both', marginTop: '60px' }}>{error}</Message>
                    }

                    <Modal open={modalOpen} onClose={this.closeModal}>
                        <Modal.Header>
                            Poista asiakas
                        </Modal.Header>

                        <Modal.Content>
                            <p>Haluatko varmasti poistaa asiakkaan? Tämä ei poista kohteiden mittaustilastoja.</p>
                        </Modal.Content>

                        <Modal.Actions>
                            <Button
                                positive
                                content="Poista"
                                onClick={this.deleteClient}
                                disabled={loading}
                            />
                            <Button
                                negative
                                content="Peruuta"
                                onClick={this.closeModal}
                                disabled={loading}
                            />
                        </Modal.Actions>
                    </Modal>

                </Segment>
            </div>

        )
    }
}

const mapStoP = (state, ownProps) => {
    const name = ownProps.match.params.name
    const client = state.clients.data.find(client => client.name === name)
    return {
        client: client
    }
}

const mapDtoP = dispatch => {
    return {
        deleteClient: name => dispatch(deleteClient(name))
    }
}

export default connect(mapStoP, mapDtoP)(ClientDetails)


// WEBPACK FOOTER //
// ./src/Admin/Clients/ClientDetails.js